<template>
    <!-- 审核管理 - 待我确认 -->
    <content-view class="verify">
        <div slot="header">
            <a-form :form="form" layout="inline" class="store-one-form">
                <a-form-item label="审核类型：">
                    <a-select v-decorator="['source']" placeholder="请选择" allowClear @select="search">
                        <!-- <a-select-option :value="1">票劵退款审批</a-select-option>
                        <a-select-option :value="2">出库审批</a-select-option>
                        <a-select-option :value="3">调拨审批</a-select-option> -->
                        <a-select-option value="REFUND">票券退款</a-select-option>
                        <!-- <a-select-option :value="6">营销订单审批</a-select-option>
                        <a-select-option :value="7">仓储中心出库审批</a-select-option>
                        <a-select-option :value="8">仓储中心调拨审批</a-select-option>
                        <a-select-option :value="9">仓储中心商品删除审批</a-select-option> -->
                    </a-select>
                </a-form-item>
                <a-form-item label="审核状态：">
                    <a-select
                        v-decorator="['state']"
                        placeholder="请选择"
                        allowClear
                        @select="search"
                    >
                        <a-select-option value="0">审批中</a-select-option>
                        <a-select-option value="1">审批通过</a-select-option>
                        <a-select-option value="-1">审批不通过</a-select-option>
                        <a-select-option value="-2">已撤回</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item class="wrap-header-button">
                    <a-button class="mr8" type="primary" @click="search">筛选</a-button>
                    <a-button @click="resetForm">重置</a-button>
                </a-form-item>
            </a-form>
        </div>
        <div class="wrap-container-in">
            <a-table
                bordered
                :dataSource="dataSource"
                :columns="columns"
                :pagination="pagination"
                @change="changePage"
                :rowKey="record => record.id"
                :loading="loading"
            >
                <template slot="index" slot-scope="text,record,index">{{index+1}}</template>
                <template slot="submitTime" slot-scope="submitTime">{{submitTime && submitTime.replace('T', ' ')}}</template>
                <template slot="approvalTime" slot-scope="approvalTime">{{approvalTime ? approvalTime.replace('T', ' ') : "-"}}</template>
                <template slot="source" slot-scope="a">
                    {{source[a]}}
                </template>
                <template slot="state" slot-scope="text">
                    {{$utils.auditState[String(text)]}}
                </template>
                <template slot="action" slot-scope="record">
                    <a v-if="getBtnByAuth('verifyDetail')" class="text-primary" @click="showModal(record)">查看详情</a>
                </template>
            </a-table>
        </div>
        <a-modal v-model="isNeedModal" @cancel="isNeedModal = false" :footer="false" centered>
            <div class="text-center mt48 mb48">
                <a-icon class="text-success" type="check-circle" style="font-size: 64px" />
                <div class="font-bigger font-bold mt24 mb24">审核通过未退款</div>
                <div v-if="payMode == 4" class="text-fail">该笔订单为现金支付，请进行线下退款流程</div>
                <div v-else-if="payMode == 11 && isManualPayment" class="text-fail">该笔订单在人工确认后完成，需进行线下退款流程</div>
                <div v-else class="text-fail">*该笔订单系统<span class="font-biggest">无法</span>自动退款。请完成线下退款流程。</div>
            </div>
        </a-modal>
        <order-refund ref="refundOrder" @changeVisibleRefund="changeVisibleRefundOrder" :verifyId="verifyId" :businessId="businessId"  :visibleRefund="visibleOrderRefundOrder" :isVerify="isVerifyOrder"></order-refund>
    </content-view>
</template>

<script type="text/javascript">
    import orderRefund from "@/components/modules/audit/order-refund.component";
    import { mapGetters } from "vuex";
    //  默认表头
    const columns = [
        {
            title: "序号",
            scopedSlots: { customRender: "index" }
        },
        {
            title: "发起审核类型",
            dataIndex: "source",
            scopedSlots: { customRender: "source" }
        },
        // {
        //     title: "票券订单号",
        //     dataIndex: "businessId",
        //     scopedSlots: { customRender: "businessId" }
        // },
        {
            title: "发起人",
            dataIndex: "submitterName"
        },
        {
            title: "审核状态",
            dataIndex: "state",
            scopedSlots: { customRender: "state" }
        },
        {
            title: "发起时间",
            dataIndex: "submitTime",
            scopedSlots: { customRender: "submitTime" }
        },
        {
            title: "审核时间",
            dataIndex: "approvalTime",
            scopedSlots: { customRender: "approvalTime" }
        },
        {
            title: "操作",
            scopedSlots: { customRender: "action" }
        }
    ];
export default {
    /**
     * @columns {array} 页面数据表的表头
     * @dataSource {array} 页面数据表的数据
     * @pagination {object} 页面数据表的分页器参数
     * @visibalRefund {boolean} 退款弹窗渲染条件
     * @visibleOATitle {boolean} 出库调拨弹窗标题
     * @currentRecord {object} 当前弹窗的数据记录
     * @sysRoleList {array} 角色列表
     * @sysUserList {array} 用户列表
     * @currentRoleId {string} 选中角色的id
     */
    name: "verify",
    components: {},
    props: {},
    data() {
		const source = {
			REFUND: "票券退款"
		}
        return {
            columns,
            source,
            dataSource: [],
            pagination: {
                showTotal: total => `共 ${total} 条数据`,
                current: 1,
                pageSize: 20,
                showQuickJumper: true,
                showSizeChanger: true,
                total: 0
            },
            visibleRefund: false,
            visibleOATitle: "商品出库申请",
            currentRecord: {},
            sysRoleList: [],
            currentRoleId: 0,
            sysUserList: [],
            loading: false,
            verifyId: '',
            businessId: '',
            visibleOrderRefundOrder: false,
            isVerifyOrder: false,
            isNeedModal: false,
            isManualPayment: undefined,
            payMode: undefined
        };
    },
    computed: {
        ...mapGetters(["shopId"])
    },
    components: {
        orderRefund,
    },
    methods: {
        // 表格控件操作回调
        /**
         * @pagination 表格分页器操作回调的分页参数
         * @filters 表格筛选操作回调的参数
         * @sorter 表格排序操作回调的参数
         */
        changePage(page) {
            this.pagination.pageSize = page.pageSize
            this.pagination.current = page.current
            this.getList();      
        },
        showModal(record) {
            this.currentRecord = record;
            // 订单退款详情
            this.isVerifyOrder = record.state === 0;
            this.visibleOrderRefundOrder = true;
            this.verifyId = record.id.toString();
            this.businessId = record.businessId;
        },
        // 获取审核管理我发起的表格数据
        /**
         * @validateFields 表格提交事件监听回调
         * @body 接口请求参数
         * @pageNum 查询数据的目标页码
         * @pageSize 查询数据的一页条数
         * @state 查询数据状态
         */
        getList() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.loading = true;
                    this.$api.audit.listByConfirm({
                        body: {
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize,
                            state: values.state,
                            type: values.type
                        }
                    }).then(data => {
                        this.dataSource = data.list;
                        this.pagination.total = data.total;
                        this.loading = false;
                    }).catch(err => {
                        this.loading = false;
                    })
                }
            });
        },
        /**
         * @getSysRoleList {method} 获取角色类型列表
         */
        getSysRoleList() {
            if(!this.shopId) return
            this.$api.audit.sysRoleRefund({
            }).then(res => {
                this.sysRoleList = res;
            });
        },
        /**
         * @getSysUserList {method} 获取用户列表
         */
        getSysUserList() {
            if(!this.shopId) return
            this.$api.audit.sysUserRefund({
                    query: {
                        shopId: this.shopId,
                        roleId: this.currentRoleId
                    }
                }).then(res => {
                this.sysUserList = res;
            });
        },
        /**
         * @roleChange {method} 角色选择框改变事件
         */
        roleChange(value) {
            this.currentRoleId = value;
            this.getSysUserList()
        },
        resetForm () {
            this.form.resetFields();
			this.search();
        },
        search() {
            this.pagination.current = 1;
            this.getList();
        },
        // 打开、关闭订单退款详情弹框
        changeVisibleRefundOrder(val) {
            this.visibleOrderRefundOrder = val.visibleOrderRefundOrder;
            this.isNeedModal = val.isNeedModal;
            this.payMode = val.payMode;
            this.isManualPayment = val.isManualPayment;
            // this.getDetail();
            this.getList();
        },

    },
    beforeCreate() {
        this.form = this.$form.createForm(this);
    },
    created() {},
    mounted() {
        this.getSysRoleList();
        this.getList();
    },
    watch: {
        'shopId'() {
            this.getSysRoleList()
        }
    }
};
</script>
<style lang="scss">
.verify {
    &-vip-card {
        background: #fafafa;
        border-radius: 4px;
        border: 1px solid #e9e9e9;
        .text-black-ap65 {
            color: rgba(0, 0, 0, 0.65);
        }
    }
}
</style>